export const ALBUM_KEY = 'album';
export const USER_KEY = 'user';
export const VIDEO_KEY = 'video';
export const LIVE_EVENTS_KEY = 'live_events';

/*
 * Grid layout constants
 */
export const HALF_WIDTH = 12;
export const VIMEO_BLUE = '#00adef';

/**
 * Responsive
 */
export const MOBILE_BREAKPOINT = 500;

/**
 * Stock Privacy
 */
export const STOCK_PRIVACY = 'stock';

/**
 * Customization constants from PHP Class
 */
export const LAYOUT_GRID = 'grid';
export const LAYOUT_PLAYER = 'player';
export const LAYOUT_LIVE = 'live';
export const LAYOUT_PLAYLIST = 'playlist';
export const THEME_STANDARD = 'standard';
export const THEME_DARK = 'dark';

export const SORT_ARRANGED = 'arranged';
export const SORT_NEWEST = 'newest';
export const SORT_OLDEST = 'oldest';
export const SORT_PLAYS = 'plays';
export const SORT_COMMENTS = 'comments';
export const SORT_LIKES = 'likes';
export const SORT_ADDED_FIRST = 'added_first';
export const SORT_ADDED_LAST = 'added_last';
export const SORT_ALPHABETICAL = 'alphabetical';

export const SEARCH_PAGE_SIZE = 25;

export const DEFAULT_SORT = {
  sort: 'default',
};

export const ALBUM_SORTS = {
  [SORT_ALPHABETICAL]: {
    sort: 'alphabetical',
    direction: 'asc',
  },
  [SORT_NEWEST]: {
    sort: 'date',
    direction: 'desc',
  },
  [SORT_OLDEST]: {
    sort: 'date',
    direction: 'asc',
  },
  [SORT_LIKES]: {
    sort: 'likes',
    direction: 'desc',
  },
  [SORT_PLAYS]: {
    sort: 'plays',
    direction: 'desc',
  },
  [SORT_COMMENTS]: {
    sort: 'comments',
    direction: 'desc',
  },
  [SORT_ARRANGED]: { sort: 'manual' },

  // Deprecated: Cannot support with API sorting
  [SORT_ADDED_FIRST]: DEFAULT_SORT,

  // Deprecated: Cannot support with API sorting
  [SORT_ADDED_LAST]: DEFAULT_SORT,
};

/**
 * Default customization settings
 */
export const DEFAULT_CUSTOMIZATIONS = {
  brandColor: VIMEO_BLUE,
  customLogo: null,
  file: null,
  hideNav: false,
  layout: LAYOUT_GRID as string,
  logo: '',
  logoUrl: '',
  theme: THEME_STANDARD as string,
};

/**
 * Z-Index
 */
export const CREATOR_ACTION_BAR_Z_INDEX = 13;
export const TITLE_CARD_Z_INDEX = 100;
export const ACTIVE_PLAYER_Z_INDEX = 103;
export const ACTION_ARROW_Z_INDEX = 104;

/**
 * Album request fields
 */

export const albumRequestFields = [
  'allow_continuous_play',
  'allow_downloads',
  'allow_share',
  'autoplay',
  'brand_color',
  'custom_logo',
  'description',
  'domain',
  'embed',
  'hide_nav',
  'hide_upcoming',
  'layout',
  'name',
  'pictures.sizes.link',
  'pictures.uri',
  'has_chosen_thumbnail',
  'pictures.type',
  'privacy',
  'share_link',
  'sort',
  'theme',
  'unlisted_hash',
  'user.uri',
  'web_custom_logo',
  'web_brand_color',
  'metadata.connections.videos.total',
];

export const albumVideosRequestFields = [
  'description',
  'duration',
  'is_free',
  'live',
  'name',
  'pictures.sizes.link',
  'pictures.sizes.width',
  'pictures.uri',
  'privacy.download',
  'privacy.view',
  'content_rating_class',
  'type',
  'uri',
  'user.link',
  'user.name',
  'user.pictures.sizes.link',
  'user.pictures.sizes.width',
  'user.uri',
];

export const SECONDS_IN_MINUTE = 60;
export const SECONDS_IN_HOUR = SECONDS_IN_MINUTE * 60;

// SU,MO,TU,WE,TH,FR,SA
export const DAY_TO_NUMBER_MAPPING = {
  SU: 0,
  MO: 1,
  TU: 2,
  WE: 3,
  TH: 4,
  FR: 5,
  SA: 6,
};

export const VIMEO_PROD_DOMAIN = 'https://vimeo.com';
export const VIMEO_DEV_DOMAIN = 'https://vimeo.dev';
